import { render, staticRenderFns } from "./RegresarStock.vue?vue&type=template&id=645afe02&"
import script from "./RegresarStock.vue?vue&type=script&lang=js&"
export * from "./RegresarStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports